/* eslint-disable showpass-custom/no-hardcoded-colors */
/* eslint-disable showpass-custom/no-hardcoded-style-values */
import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function SquareLogo({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <SquareLogo.Outline {...props} />
  ) : (
    <SquareLogo.Solid {...props} />
  );
}

SquareLogo.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For outlined icons, be sure to add `className="icon-outline"`
         * to each path that needs to be outlined.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

SquareLogo.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <g clipPath="url(#clip0_3656_24289)">
          <path
            d="M24.9863 0H5.01374C2.24299 0 0 2.16822 0 4.84662V24.1534C0 26.8318 2.24299 29 5.01374 29H24.9863C27.757 29 30 26.8318 30 24.1534V4.84662C30 2.16822 27.757 0 24.9863 0ZM24.541 22.2084C24.541 23.0533 23.8318 23.7389 22.9577 23.7389H7.04233C6.16822 23.7389 5.45904 23.0533 5.45904 22.2084V6.80759C5.45904 5.96262 6.16822 5.27708 7.04233 5.27708H22.9742C23.8483 5.27708 24.5574 5.96262 24.5574 6.80759V22.2084H24.541Z"
            fill="currentColor"
          />
          <path
            d="M11.8252 18.4308C11.3139 18.4308 10.9181 18.0322 10.9181 17.5539V11.4159C10.9181 10.9217 11.3304 10.5391 11.8252 10.5391H18.1913C18.6861 10.5391 19.0984 10.9376 19.0984 11.4159V17.5539C19.0984 18.0481 18.6861 18.4308 18.1913 18.4308H11.8252Z"
            fill="currentColor"
          />
        </g>
      </>
    ),
  });

  return (
    <Icon
      w="element.xl"
      h="element.xl"
      viewBox="0 0 30 29"
      {...validateKeys(props)}
    />
  );
};
